<template>
  <div>
    <v-progress-linear :indeterminate="true"
                       v-if="loading"
                       color="green"
                       class="p-1 pt-0"
                       height="5"></v-progress-linear>
    <v-form v-else>
      <gg-text-field
        label="New Database"
        name="New Database"
        :prefix="newDBPrefix"
        v-model="newDBName"
        :counter="maxlength"
        v-validate="`required|max:${maxlength}`"
        :error-messages="errors.collect('New Database')"
      />
      <gg-btn
        :loading="isLoading"
        v-if="submitButton"
        @click="createDatabase"
        class="ml-0"
      >
        Create Database
      </gg-btn>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { randomName } from '@/helpers/helpers'

export default {
  name: 'CreateDatabaseForm',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    submitButton: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      newDBName: '',
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      mysqlRestrictions: 'mysql/mysqlRestrictions'
    }),
    newDBPrefix () {
      return this.mysqlRestrictions.prefix || false
    },
    newDBFullName () {
      return `${this.newDBPrefix}${this.newDBName}`
    },
    maxlength () {
      const maxlength = this.mysqlRestrictions.max_database_name_length || 0
      return this.newDBPrefix ? maxlength - this.newDBPrefix.length : maxlength
    },
  },
  methods: {
    ...mapActions({
      getMysqlDatabases: 'mysql/getMysqlDatabases',
      createMysqlDatabase: 'mysql/createMysqlDatabase',
      getMysqlUsers: 'mysql/getMysqlUsers',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess',
    }),
    async createDatabase () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.$emit('loading-start')
      this.isLoading = true
      try {
        await this.createMysqlDatabase({ name: this.newDBFullName, _username: this.$route.query.user })
        this.reportSuccess(`Added the database "${this.newDBFullName}".`)
        this.$emit('database-created', this.newDBFullName)
        this.reset()
      } catch (e) {
        this.reportError(e)
      }
      this.isLoading = false
      this.$emit('loading-stop')
    },
    reset () {
      this.generateName()
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    generateName () {
      const length = 14
      this.newDBName = randomName(length)
    },
  },
  created () {
    // Alternative to 'Create Database' button
    this.$on('create-database', () => {
      this.createDatabase()
    })
    this.generateName()
  },
  beforeDestroy () {
    this.$off('create-database')
  },
}
</script>
